import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";

const LinkButton = ({
  href,
  color,
  large,
  classNames,
  children,
  onClick,
  useAnchor = false,
}) => (
  useAnchor ? (
    <a
      href={href || ""}
      onClick={onClick}
      className={`btn btn--${color} ${large ? "btn--large" : ""} ${
        classNames ? classNames.join(" ") : ""
      }`}
    >
      {children}
    </a>
  ) : (
    <Link href={href || ""} >
      <a className={`btn btn--${color} ${large ? "btn--large" : ""} ${classNames ? classNames.join(" ") : "" }`}>
        {children}
      </a>
    </Link>
  )
);

LinkButton.propTypes = {
  href: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  large: PropTypes.bool,
  classNames: PropTypes.array,
  children: PropTypes.any.isRequired,
};

LinkButton.defaultProps = {
  large: false,
  classNames: [],
};

export default LinkButton;
